import { langCheck } from "Pub/js/utils.js";

const getMeta = () => {
    return {
        code: 'subject-preview',
        name: '个性化设置-预览',
        preview_query: {
            items: [
                {
                    isdrag: true, // 是否可拖拽
                    disabled: false, // 是否可用
                    attrcode: "mdidRef",
                    itemtype: "refer",
                    label: langCheck('0000PUB-000582'),
                    required: true,
                    visible: true,
                    refcode: "uap/refer/riart/responsibilityTabelRef/index",
                    col: 3, // 布局信息
                    leftspace: 0, // 左侧空白区域
                    rightspace: 0, // 右侧空白区域
                    queryOperateType: '=@between@=@<', // 操作符
                    visibleposition: '0',
                },
                {
                    isdrag: true, // 是否可拖拽
                    disabled: false, // 是否可用
                    attrcode: 'datepicker', // 字段field
                    label: langCheck("0000PUB-000583"), // 字段名称
                    itemtype: 'refer', // 字段类型
                    required: false, // 是否必输
                    visible: true, // 是否显示
                    col: 3, // 布局信息
                    leftspace: 0, // 左侧空白区域
                    refcode: "uap/refer/riart/responsibilityTabelRef/index",
                    rightspace: 0, // 右侧空白区域
                    queryOperateType: '=@between@=@<', // 操作符
                    isfixedcondition: false,
                    visibleposition: '0',
                },
                {
                    isdrag: true, // 是否可拖拽
                    disabled: false, // 是否可用
                    attrcode: 'datepicker1', // 字段field
                    label: langCheck("0000PUB-000584"), // 字段名称
                    itemtype: 'input', // 字段类型
                    required: false, // 是否必输
                    visible: true, // 是否显示
                    col: 3, // 布局信息
                    leftspace: 0, // 左侧空白区域
                    rightspace: 0, // 右侧空白区域
                    queryOperateType: '=@between@=@<', // 操作符
                    isfixedcondition: false,
                },
            ],
            moduletype: 'search',
            isunfold: true,
            queryschemes: [
                {
                    isquickqs: false,
                    name: '测试方案',
                    renderobj4web: [
                        {
                            required: false,
                            // disabled:true,
                            queryOperateType: '=@between@<',
                            visible: true,
                            attrcode: 'root',
                            isEmpty: false,
                            noRemove: true,
                            operationSign: 'and',
                            refpk: 'root',
                            children: [
                                {
                                    required: false,
                                    // disabled:true,
                                    queryOperateType: '=@between@<',
                                    visible: true,
                                    attrcode: 'money',
                                    initialvalue: {
                                        value: '0,1',
                                        display: 'aaa,222',
                                    },
    
                                },
                                {
                                    required: false,
                                    disabled: false,
                                    isdrag: true,
                                    queryOperateType: '=@between@<',
                                    visible: true,
                                    attrcode: 'datepicker',
                                    operationSign: 'between',
                                    initialvalue: {
                                        value: '',
                                        display: '',
                                    },
                                },
                            ],
                        }],
                }
            ],
        },
        preview_head: {
            items: [
                {
                    "ishighlight": false,
                    "isbold": false,
                    "showasrange": false,
                    "anotherline": false,
                    "tabskip": false,
                    "hyperlinkflag": false,
                    "islock": false,
                    "istotal": false,
                    "ishidefieldname": false,
                    "attrcode": "pk_group",
                    "containlower": false,
                    "datatype": "204",
                    "disabled": false,
                    "editAfterFlag": false,
                    "fieldDisplayed": "refname",
                    "fieldValued": "refpk",
                    "initialvalue": {},
                    "isDataPowerEnable": true,
                    "isMultiSelectedEnabled": false,
                    "isnotmeta": false,
                    "isResLabel": false,
                    "isrevise": false,
                    "isShowUnit": false,
                    "itemtype": "refer",
                    "label": langCheck('0000PUB-000648'),
                    "maxlength": "20",
                    "metadataProperty": "uap.group.name",
                    "metapath": "pk_group.name",
                    "newmetapath": "pk_group",
                    "onlyLeafCanSelect": false,
                    "position": "2",
                    "refcode": "uap/refer/riart/groupTreeRef/index",
                    "required": false,
                    "scale": "0",
                    "visible": true,
                    "isgrouppower": false,
                    "isuserdef": false,
                    "dataval": "0001Z010000000000ZKS,code=N",
                    "refenter": false,
                    "multiplelines": false,
                    "editdisabled": false
                },
                {
                    "ishighlight": false,
                    "isbold": false,
                    "showasrange": false,
                    "anotherline": false,
                    "tabskip": false,
                    "hyperlinkflag": false,
                    "islock": false,
                    "istotal": false,
                    "width": "140px",
                    "ishidefieldname": false,
                    "attrcode": "pk_org_v",
                    "containlower": false,
                    "datatype": "204",
                    "disabled": true,
                    "editAfterFlag": false,
                    "fieldDisplayed": "refname",
                    "fieldValued": "refpk",
                    "initialvalue": {},
                    "isDataPowerEnable": true,
                    "isMultiSelectedEnabled": false,
                    "isnotmeta": false,
                    "isResLabel": false,
                    "isrevise": false,
                    "isShowUnit": false,
                    "itemtype": "refer",
                    "label": langCheck("0000PUB-000583"),
                    "maxlength": "20",
                    "metadataProperty": "uap.stockorg_v.name",
                    "onlyLeafCanSelect": false,
                    "position": "3",
                    "refcode": "uapbd/refer/orgv/StockOrgVersionGridRef/index",
                    "required": false,
                    "scale": "0",
                    "visible": true,
                    "isgrouppower": false,
                    "isuserdef": false,
                    "dataval": "0001Z01000000002V015,code=N",
                    "refenter": false,
                    "multiplelines": false,
                    "editdisabled": false
                },
                {
                    "ishighlight": false,
                    "isbold": false,
                    "showasrange": false,
                    "anotherline": false,
                    "tabskip": false,
                    "hyperlinkflag": false,
                    "islock": false,
                    "istotal": false,
                    "width": "140px",
                    "ishidefieldname": false,
                    "attrcode": "vbillcode",
                    "containlower": false,
                    "datatype": "1",
                    "disabled": false,
                    "editAfterFlag": false,
                    "fieldDisplayed": "refname",
                    "fieldValued": "refpk",
                    "initialvalue": {},
                    "isDataPowerEnable": true,
                    "isMultiSelectedEnabled": false,
                    "isnotmeta": false,
                    "isResLabel": false,
                    "isrevise": false,
                    "isShowUnit": false,
                    "itemtype": "input",
                    "label": langCheck('0000PUB-000214'),
                    "maxlength": "40",
                    "onlyLeafCanSelect": false,
                    "position": "5",
                    "required": false,
                    "scale": "0",
                    "visible": true,
                    "isgrouppower": false,
                    "isuserdef": false,
                    "refenter": false,
                    "multiplelines": false,
                    "editdisabled": false
                },
                {
                    label: langCheck('0000PUB-000457'),
                    attrcode: 'opr',
                    itemtype: 'customer',
                    fixed: 'right',
                    visible: true,
                    width: 180,
                    render: () => {
                        // return props.button.createOprationButton(['edit', 'delete'], {
                        //     area: 'table_opr',
                        // });
                        // 这里先自定义渲染，需要实时预览，如果要用createOprationButton的话，需要button做适配
                        return [
                            <a style={{ marginRight: '12px' }}>{langCheck('0000PUB-000489')}</a>,
                            <a style={{ marginRight: '12px' }}>{langCheck('0000PUB-000581')}</a>
                        ]
                    },
                }
            ],
            "moduletype": "table",
        },
        preview_form: {
            'items': [
                {
                    'rows': '1',
                    'attrcode': 'pk_org_v_1',
                    'itemtype': 'input',
                    'label': langCheck('0000PUB-000067'), // 所属组织
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'ctrantypeid',
                    'itemtype': 'input',
                    'label': langCheck('0000PUB-000035'), // 账簿类型
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'dbilldate',
                    'itemtype': 'datepicker',
                    'label': langCheck('0000PUB-000115'), // 业务日期
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'pk_supplier',
                    'itemtype': 'input',
                    'label': langCheck('0000PUB-000583'), // 供应商
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'pk_invcsupllier',
                    'label': langCheck('0000PUB-000580'), // 交易类型
                    'itemtype': 'input',
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'corigcurrencyid',
                    'label': langCheck('0000PUB-000582'), // 应收财务组织
                    'itemtype': 'input',
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'pk_payterm',
                    'label': langCheck('0000PUB-000015'), // 数据类型
                    'itemtype': 'input',
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'cemployeeid',
                    'label': langCheck('0000PUB-000145'), // 地址
                    'itemtype': 'input',
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'pk_dept_v',
                    'label': langCheck('0000PUB-000070'), // 部门
                    'itemtype': 'input',
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'breturn',
                    'itemtype': 'checkbox_switch',
                    'label': langCheck('0000PUB-000043'), // 包含下级
                    'options': [],
                    'required': true,
                    'visible': true
                },
                {
                    'label': langCheck('0000PUB-000558'), // 上下排列
                    'attrcode': 'bisreplenish',
                    'itemtype': 'checkbox_switch',
                    'options': [],
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'brefwhenreturn',
                    'itemtype': 'checkbox_switch',
                    'label': langCheck('0000PUB-000031'), // 集团(所有)
                    'options': [],
                    'required': true,
                    'visible': true
    
                },
                {
                    'attrcode': 'ntotalastnum',
                    'disabled': true,
                    'itemtype': 'number',
                    'label': langCheck('0000PUB-000032'), // 编码
                    'visible': true
                },
                {
                    'attrcode': 'ntotalorigmny',
                    'disabled': true,
                    'itemtype': 'number',
                    'label': langCheck('0000PUB-000033'), // 名称
                    'visible': true
                },
                {
                    'attrcode': 'forderstatus',
                    'itemtype': 'select',
                    'label': langCheck('0000PUB-000051'), // 单据类型
                    'options': [],
                    'required': true,
                    'visible': true
                },
                {
                    'attrcode': 'vmemo',
                    'itemtype': 'input',
                    'label': langCheck('0000PUB-000465'), // 网址
                    'maxlength': '181',
                    'required': false,
                    'visible': true
                }
            ],
            'moduletype': 'form',
            'status': 'add'
        },
    };
}
const searchId = 'preview_query';
const tableId = 'preview_head';
const formId = 'preview_form';
const getJson = () => {
    return [
        {
            type: 'general_btn',
            key: 'main',
            btncolor: 'button_main',
            title: langCheck("0000PUB-000580"),
            area: 'general_btn',
            keyboard: 'alt+q',
            pageareacode: 'page_header',
        },
        {
            type: 'general_btn',
            btncolor: 'button_secondary',
            key: 'secondary',
            title: langCheck("0000PUB-000435"),
            area: 'general_btn',
            keyboard: 'Ctrl+Z',
        },
        {
            type: 'general_btn',
            key: 'edit',
            title: langCheck('0000PUB-000489'), // 编辑,
            area: 'table_opr',
        },
        {
            type: 'general_btn',
            key: 'delete',
            title: langCheck('0000PUB-000581'), // 删除
            area: 'table_opr',
        }
    ];
}
const initTemplate = function (props) {
    props.use.table(tableId);
    props.use.form(formId);
    props.meta.setMeta(getMeta());
    props.button.setButtons(getJson());
    // 模拟表格数据及选中行
    props.table.setAllTableData(tableId, {
        rows: [
            {
                values: {
                    pk_group: { value: langCheck('0000PUB-000065') }
                }
            },
            {
                values: {
                    pk_org_v: { value: langCheck('0000PUB-000070') }
                }
            },
            {
                values: {
                    vbillcode: { value: '137****1234' }
                }
            },
            {
                values: {
                    vbillcode: { value: '137****1234' }
                }
            },
            {
                values: {
                    vbillcode: { value: '137****1234' }
                }
            },
            {
                values: {
                    vbillcode: { value: '137****1234' }
                }
            }
        ]
    }, false, false, false)
    props.table.selectTableRows(tableId, 1, true);
};

// 桌面数据有些多语是配置在里边的，有的是需要实时翻译，具体得看这个应用或者部件有没有启用公共配置项
const getDesktopPreviewData = () => {
    return {
        pk_app_group: "1001AZ1000000002JUW1",
        groupname: "分组",
        workbenchid: "1001AZ1000000002ICRZ",
        position: "0",
        creationtime: "2023-08-14 17:14:32",
        dr: "0",
        ts: "2023-08-14 17:22:40",
        apps: [
            {
                gridx: "0",
                gridy: "0",
                width: "16",
                height: "4",
                cardid: "0001Z01000000000UKBJ",
                name: "消息中心",
                target_path: "/nccloud/resources/uap/msgcenter/widget/messageCenter/index.js",
                apptype: "2",
                uselicense_load: true,
                orgtypecode: "GLOBLE00000000000000",
                funtype: "3",
                parent_id: "0001Z0100000000042SC",
                isenable: true,
                iscauserusable: false,
                haspower: true,
                source_app_code: "10160511",
                own_module: "1016",
                fun_property: "1",
                pk_app_group: "1001A11000000009IUJ0",
                pk_group_app: "1001A11000000009IUJ3",
                isreleasepart: false,
                ownlicense_load: true,
                partname: "消息中心小部件",
                component_configuration: "{\"name\":{\"name\":{\"value\":\"消息中心小部件\"}}}",
                menuitemcode: "10160511",
                menuitemname: "消息中心小部件",
                appcode: "10160511",
                appid: "0001Z01000000000UKBF",
                pk_menu: "1004Z510000000000FFL",
                parentcode: "101605",
                resid: "APPMU10160511",
                image_src: "/message",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-11-10 22:13:15",
                valueIndex: {
                    creator: "0001Z0100000000003Y1",
                    code: "10160511",
                    modifiedtime: "2021-08-27 14:39:21",
                    modifier: "0001Z0100000000002CE",
                    creationtime: "2018-07-03 20:40:58",
                    pk_appregister: "0001Z01000000000UKBF",
                    iscopypage: "N",
                },
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "16",
                gridy: "0",
                width: "8",
                height: "8",
                cardid: "1001Z51000000001BV2B",
                name: "日程管理",
                target_path: "/nccloud/resources/uap/imp/widget/calendarSchedule/index.js",
                apptype: "2",
                uselicense_load: true,
                orgtypecode: "GLOBLE00000000000000",
                funtype: "3",
                parent_id: "1001Z51000000001BV1V",
                isenable: true,
                iscauserusable: false,
                haspower: true,
                source_app_code: "10182002",
                own_module: "1018",
                fun_property: "0",
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUW5",
                isreleasepart: false,
                ownlicense_load: true,
                component_configuration: "{\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name\":{\"value\":\"日程管理\"}}},\"name\":{}}",
                menuitemcode: "10182002",
                menuitemname: "日程管理",
                menuitemname2: "tr日程管理",
                menuitemname3: "en日程管理",
                appcode: "10182002",
                appid: "1001Z51000000001BV23",
                pk_menu: "1004Z510000000000FFL",
                parentcode: "101820",
                image_src: "/calendar",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-11 11:21:26",
                valueIndex: {
                    creator: "1001A310000000000TDD",
                    code: "10182002",
                    modifiedtime: "2021-08-06 16:33:02",
                    modifier: "1001A310000000000TDD",
                    creationtime: "2021-07-15 13:41:47",
                    pk_appregister: "1001Z51000000001BV23",
                    iscopypage: "N",
                },
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "12",
                gridy: "4",
                width: "4",
                height: "4",
                cardid: "1001Z51000000001BV2A",
                name: "新手引导",
                target_path: "/guide",
                apptype: "2",
                uselicense_load: true,
                orgtypecode: "GLOBLE00000000000000",
                funtype: "3",
                parent_id: "1001Z51000000001BV1V",
                isenable: true,
                iscauserusable: false,
                haspower: true,
                source_app_code: "10182001",
                own_module: "1018",
                fun_property: "0",
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUW6",
                isreleasepart: false,
                ownlicense_load: true,
                component_configuration: "{\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name\":{\"value\":\"新手引导\"}}},\"name\":{}}",
                menuitemcode: "10182001",
                menuitemname: "新手引导",
                menuitemname2: "tr新手引导",
                menuitemname3: "en新手引导",
                appcode: "10182001",
                appid: "1001Z51000000001BV21",
                pk_menu: "1004Z510000000000FFL",
                parentcode: "101820",
                image_src: "/guide",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-11 11:21:26",
                valueIndex: {
                    creator: "1001A310000000000TDD",
                    code: "10182001",
                    modifiedtime: "2021-08-06 16:30:00",
                    modifier: "1001A310000000000TDD",
                    creationtime: "2021-07-15 13:40:32",
                    pk_appregister: "1001Z51000000001BV21",
                    iscopypage: "N",
                },
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "0",
                gridy: "8",
                width: "4",
                height: "4",
                cardid: "0001Z010000000001WX8",
                name: langCheck('0000PUB-000454'), // 集团
                target_path: "0001Z01000000000155T",
                apptype: "1",
                uselicense_load: true,
                orgtypecode: "GROUPORGTYPE00000000",
                funtype: "3",
                parent_id: "0001Z010000000000EO8",
                isenable: true,
                iscauserusable: false,
                mdid: "3b6dd171-2900-47f3-bfbe-41e4483a2a65",
                haspower: true,
                source_app_code: "10100GRP",
                own_module: "1010",
                fun_property: "0",
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUW8",
                isreleasepart: false,
                component_configuration: "{\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name\":{\"value\":\"集团\"}}},\"name\":{}}",
                menuitemcode: "10100203",
                menuitemname: "集团",
                menuitemname2: "tr集团",
                menuitemname3: "en集团",
                appcode: "10100GRP",
                appid: "0001Z01000000000155S",
                pk_menu: "1004Z510000000000FFL",
                parentcode: "101002",
                resid: "APP10100203",
                image_src: "yewushezhilei5",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-14 09:44:19",
                valueIndex: {
                    code: "10100GRP",
                    modifiedtime: "2019-02-21 10:10:49",
                    modifier: "0001HR100000000005MM",
                    pk_appregister: "0001Z01000000000155S",
                    iscopypage: "N",
                },
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "4",
                gridy: "8",
                width: "4",
                height: "4",
                cardid: "0001Z010000000004F4V",
                name: langCheck('0000PUB-000055'), // 业务单元
                target_path: "0001Z010000000001NOK",
                apptype: "1",
                uselicense_load: true,
                orgtypecode: "BUSINESSUNIT00000000",
                funtype: "3",
                parent_id: "0001Z010000000000EO8",
                isenable: true,
                iscauserusable: false,
                mdid: "985be8a4-3a36-4778-8afe-2d8ed3902659",
                haspower: true,
                source_app_code: "10100ORG",
                own_module: "1010",
                fun_property: "0",
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUW9",
                isreleasepart: false,
                component_configuration: "{\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name\":{\"value\":\"业务单元\"}}}}",
                menuitemcode: "10100212",
                menuitemname: "业务单元",
                menuitemname2: "tr业务单元",
                menuitemname3: "en业务单元",
                appcode: "10100ORG",
                appid: "0001Z010000000001NOH",
                pk_menu: "1004Z510000000000FFL",
                parentcode: "101002",
                resid: "APP10100212",
                image_src: "yewushezhilei2",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-14 09:44:22",
                valueIndex: {
                    creator: "sun",
                    code: "10100ORG",
                    modifiedtime: "2019-02-21 10:11:32",
                    modifier: "0001HR100000000005MM",
                    creationtime: "2018-06-09 16:53:51",
                    pk_appregister: "0001Z010000000001NOH",
                    iscopypage: "N",
                },
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "0",
                gridy: "4",
                width: "8",
                height: "4",
                cardid: "1001AZ1000000002JUW2",
                name: "常用应用",
                target_path: "/apps",
                apptype: "2",
                haspower: true,
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUW7",
                isreleasepart: false,
                iscommon_configuration: true,
                parttype: "0",
                partname: "常用应用",
                component_configuration: "{\"cardList\":[],\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name3\":{\"value\":\"Favorite Apps\"},\"name\":{\"value\":\"常用应用\"},\"name2\":{\"value\":\"常用應用\"}}}}",
                children: [],
                menuitemcode: "10182003",
                appcode: "10182003",
                appid: "1001Z51000000001BV24",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-14 17:22:40",
                valueIndex: {},
                status: "0",
                m_isDirty: false,
            },
            {
                gridx: "8",
                gridy: "4",
                width: "4",
                height: "4",
                cardid: "1001AZ1000000002ICSD",
                name: langCheck('0000PUB-000387'), // 常用链接
                target_path: "/link",
                apptype: "2",
                haspower: true,
                pk_app_group: "1001AZ1000000002JUW1",
                pk_group_app: "1001AZ1000000002JUWA",
                isreleasepart: false,
                parttype: "1",
                component_configuration: "{\"publicData\":{\"nameShow\":true,\"background\":{\"type\":\"color\",\"color\":\"#FFFFFF\"},\"name\":{\"name\":{\"value\":\"常用链接\"}}},\"name\":{}}",
                menuitemcode: "10182004",
                appcode: "10182004",
                appid: "1001Z51000000001BV25",
                is_cloud_app: false,
                dr: "0",
                ts: "2023-08-14 17:22:40",
                valueIndex: {},
                status: "0",
                m_isDirty: false,
            },
        ],
        valueIndex: {},
        status: "0",
        m_isDirty: false,
    };
};

export {
    initTemplate,
    searchId,
    tableId,
    formId,
    getDesktopPreviewData,
};